import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { PfmenuPage } from './pfmenu.page';
//import { SigninPageModule } from '../../auth/signin/signin.module';

const routes: Routes = [
  {
    path: '',
    component: PfmenuPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,//SigninPageModule,
    IonicModule,TranslateModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PfmenuPage],
  providers: [TranslatePipe]
})
export class PfmenuPageModule {}
